import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from 'shared/store';

export const mechanicApiPost = createApi({
  reducerPath: 'mechanicApiPost',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['CreateMechanic', 'UpdateMechanic'],
  endpoints: (builder) => ({
    // Дублирование из features для скрытия ошибки, потом убрать
    getMe: builder.query({
      query: () => ({
        url: '',
      }),
    }),
  }),
});
